<template>
  <div class="scrollable-page">
    <v-container v-if="buildingLink" class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="text-center pa-8" elevation="2" rounded="lg">
            <h1 class="text-h5 font-weight-bold mb-2">
              Thank you for your order!
            </h1>
            <v-progress-circular
              indeterminate
              color="51627C"
              size="64"
              class="my-4"
            ></v-progress-circular>
            <p class="text-body-1 mb-4">Verifying payment...</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="purchaseStatus === 'complete'" class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="text-center pa-8" elevation="2" rounded="lg">
            <v-icon> </v-icon>
            <v-avatar size="64" color="#C6ECC6" class="mb-4">
              <v-icon size="34" icon="mdi-check" color="#517A53" />
            </v-avatar>

            <h1 class="text-h5 font-weight-bold mb-2">Payment successful!</h1>
            <p class="text-body-1 mb-4">Thank you for your order</p>

            <p class="text-body-2">
              Your order <strong>{{ orderRef }}</strong> has been confirmed.
            </p>
            <p class="text-body-2 mb-6">
              A confirmation email has been sent to
              <strong>{{ email }}</strong> with your receipt and order details.
            </p>

            <v-btn
              style="background-color: #7ad6d9"
              block
              size="large"
              class="text-white"
              :href="downloadUrl"
              rounded="0"
            >
              <div style="color: #3d5769; display: flex">
                <div>Access your order</div>
                <v-icon end>mdi-arrow-right</v-icon>
              </div>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="purchaseStatus === 'expired'" class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="text-center pa-8" elevation="2" rounded="lg">
            <v-avatar size="64" color="#FDD9AF" class="mb-4">
              <v-icon size="34" icon="mdi-clock-outline" color="#E09237" />
            </v-avatar>

            <h1 class="text-h5 font-weight-bold mb-2">This link has expired</h1>

            <p class="text-body-2">
              The download link for this order is no longer active. Links are
              available for 30 days after purchase.
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { systemMessages } from "@/mixins/SystemMessages";

export default {
  name: "ThanksForPurchase",
  mixins: [systemMessages],
  data() {
    return {
      country: "{{country}}",
      orderRef: "",
      purchaseDate: "{{purchase_date}}",
      downloadUrl: "{{download_url}}",
      email: "{{email}}",

      buildingLink: false,
      purchaseStatus: null, // 'open', 'complete', 'expired'
    };
  },
  mounted() {
    this.checkPurchaseStatus();
  },
  methods: {
    async checkPurchaseStatus() {
      this.buildingLink = true;
      const sessionID = this.$route.query?.session_id;

      if (!sessionID) {
        this.$router.push({ path: "/purchase/imd-report" });
        return;
      }

      try {
        var response = await this.$axios.get(
          `verify-imd-report-purchase/${sessionID}`,
        );

        this.purchaseStatus = response.data.status;
        if (this.purchaseStatus === "complete") {
          this.orderRef = response.data.order_id;
          this.email = response.data.email;
          this.downloadUrl = "#/" + response.data.report_link;
        }
        this.buildingLink = false;
      } catch (error) {
        this.errorMsg({
          title: "Something went wrong when verifying your purchase",
          message:
            "If you've been charged but haven't received your report, contact support as soon as possible",
          button: {
            text: "contact support",
            callback: () => {
              window.location.href = `mailto:support@ocsi.co.uk?subject=Stripe session ID: ${sessionID}`;
            },
          },
          timeout: -1,
        });
        console.error("Error checking purchase status:", error);
        this.$router.push({ path: "/purchase/imd-report" });
      }

      if (this.purchaseStatus == "open") {
        /* 
          Payment failed or incomplete. Redirect back to checkout.
          A warning will be displayed there.
        */
        this.$router.push({
          name: "OnDemandCheckOut",
          query: {
            area: response.data.area,
            ...this.$route.query,
          },
        });
      } else if (this.purchaseStatus == "complete") {
        // All data is now set in the try block
      }
    },
  },
};
</script>

<style scoped>
.scrollable-page {
  height: 100vh;
  overflow-y: auto;
  background-color: #f9f9f9;
}
</style>
